export const IMPORT_NOTIFICATION_HUB_CONSTANTS = {
  ROUTE: 'hubs/import/notifications',
  HUB_METHOD: 'ImportCompleted',
};
